/**
 * @module AEM
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { Directive, ViewContainerRef } from '@angular/core';

/**
 * Directive for targeting the Dynamic component template
 * @access private
 */
@Directive({
  selector: '[tmoDynamicHost]',
})
export class DynamicHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
